import AppColors from 'general/constants/AppColors';
import Utils from 'general/utils/Utils';
import PropTypes from 'prop-types';

CustomAlert.propTypes = {
  icon: PropTypes.string,
  title: PropTypes.string,
  message: PropTypes.string,
  color: PropTypes.string,
  bgColor: PropTypes.string,
};

function CustomAlert({
  icon,
  title,
  message,
  color = AppColors.danger,
  bgColor = 'rgba(225, 78, 84, 0.1)',
}) {
  return (
    <div
      className="p-5 d-flex flex-row gap-4"
      style={{
        border: `1px dashed ${color}`,
        backgroundColor: bgColor,
      }}
    >
      <i className={`${icon}`} style={{ color: color }} />
      <div className="d-flex flex-column gap-1">
        <span
          style={{
            color: AppColors.danger,
            fontWeight: '700',
            fontSize: Utils.convertToFontSize(20),
          }}
        >
          {title}
        </span>
        <span
          style={{
            color: 'rgba(94, 98, 120, 1)',
            fontWeight: '500',
            fontSize: Utils.convertToFontSize(14),
          }}
        >
          {message}
        </span>
      </div>
    </div>
  );
}

export default CustomAlert;
